import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {
  BannerTypes,
  MessageBannerConfig,
} from '@zipari/shared-ds-util-messages';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'custom-iframe',
  templateUrl: './custom-iframe.component.html',
  styleUrls: ['./custom-iframe.component.scss'],
})
export class CustomIframeComponent implements OnInit {
  @Input() config: any;
  @Output() postMessage: EventEmitter<any> = new EventEmitter();

  iframeSrc: SafeResourceUrl;
  errorBannerData: MessageBannerConfig;
  isError: boolean;

  @ViewChild('iframe') iframe: ElementRef;

  constructor(
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {
    const [config] = checkInputsForText([this.config]);

    this.config = config;

    if (this.config) {
      this.iframeSrc = this.config.iframeUrl
        ? this.sanitizer.bypassSecurityTrustResourceUrl(this.config.iframeUrl)
        : null;
    }

    this.errorBannerData = {
      messageHeading: this.config.error.title
        ? this.config.error.title
        : 'Failed to load iframe',
      message: this.config.error.message
        ? this.config.error.message
        : 'Something went wrong, please try again.',
      icon: 'warning',
      type: BannerTypes.error,
    };
  }

  message() {
    this.renderer.listen('window', 'message', (event) => {
      if (event.data) {
        // TODO: Check for errors
        this.postMessage.emit(event.data);
      }
    });
  }

  sendMessage(message: string | object, origin: string) {
    const loadedIframe =
      this.iframe.nativeElement.contentWindow ||
      this.iframe.nativeElement.contentDocument;

    loadedIframe.postMessage(message, origin);
  }

  iframeLoaded() {
    this.message();
  }
}
